import { Grid } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";

interface Props {
  fieldName: string;
}

export const NumberBetweenConditionValue = ({ fieldName }: Props) => {
  const { message } = useMessage();

  return (
    <Grid container spacing={12}>
      <Grid item xs={6}>
        <NumberFormatInput
          allowDecimals
          label={
            <RequiredFieldLabel
              text={message({
                id: "from",
              })}
            />
          }
          name={`${fieldName}.from`}
          inputProps={{ step: "any" }}
          data-test-id="condition-value"
        />
      </Grid>
      <Grid item xs={6}>
        <NumberFormatInput
          allowDecimals
          label={
            <RequiredFieldLabel
              text={message({
                id: "to",
              })}
            />
          }
          name={`${fieldName}.to`}
          inputProps={{ step: "any" }}
          data-test-id="condition-value"
        />
      </Grid>
    </Grid>
  );
};
